export enum TemperatureStatus {
    High = 1,
    Ideal = 2,
    Low = 3
}